export default __webpack_public_path__ + "static/media/080_finish_soso.hevc.0665252e.mp4";